import useDebounce from "../../hooks/useDebounce";
import { Cancel, Edit, RemoveCircleOutline, Search } from '@mui/icons-material'
import React, { useEffect, useState } from 'react';
import { Button, Chip, Dialog, DialogActions, DialogTitle, FormControl, Grid, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import { styled } from '@mui/system'
import "./tags.css"
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../../components/Loader/Loader'
import Toptag from '../../components/toptag/Toptag'
import apiFunctions from '../../api/apiFunctions'

const NavPaper = styled(Paper)({
    padding: "5px 12px",
    borderRadius: "0",
    backgroundColor: "white",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

const BackPaper = styled(Paper)({
    minHeight: "calc(100vh - 130px)",
    overflow: "visible",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

export default function Tags() {

    const [all, setAll] = useState([]);
    const [isLoading, setIsloading] = useState(true)
    const [usersCount, setUsersCount] = useState(0)
    const navigate = useNavigate();
    const [limit, setLimit] = useState(5);
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(1)
    const [searchKey, setSearchKey] = useState("");
    const debouncedSearch = useDebounce(searchKey, 400);
    const [statusFilter, setStatusFilter] = useState("");
    const [openDialogForStatus, setOpenDialogForStatus] = useState(false);
    const [statusTarget, setStatusTarget] = useState({ id: null, inactivate: true });
    const [dialogOpen, setDialogOpen] = useState(false)
    const [editId, setEditId] = useState(null)
    const [err, setErr] = useState(false)
    const [obj, setObj] = useState({
        title: ''
    })

    const handleStatusOpen = (id, inactivate) => {
        setStatusTarget({ id, inactivate });
        setOpenDialogForStatus(true);
    };

    const handleStatusClose = () => {
        setOpenDialogForStatus(false);
    };

    const searchHandle = (event) => {
        setSearchKey(event.target.value)
        setSkip(0);
        setPage(1);
    }

    const handleCreateOpen = () => {
        setEditId(null);
        setObj({ title: '' });
        setErr(false);
        setDialogOpen(true);
    };

    const handleEditOpen = (element) => {
        setEditId(element._id);
        setObj({ title: element.title || '' });
        setErr(false);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setEditId(null);
        setObj({ title: '' });
        setErr(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!obj.title) {
            setErr(true);
            return;
        }
        setErr(false);

        const result = editId
            ? await apiFunctions.updateTag(editId, { title: obj.title })
            : await apiFunctions.createTag({ title: obj.title });

        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            handleDialogClose();
            getAll()
            toast.success(editId ? "Tag updated successfully!" : "Tag created successfully!")
        }
    };

    const addUserData = (e) => {
        const { name, value } = e.target;
        setObj({
            ...obj,
            [name]: value,
        });
    }

    const getAll = async () => {
        const options = { activeOnly: false };
        if (statusFilter === 'true') {
            options.isDeleted = false;
        } else if (statusFilter === 'false') {
            options.isDeleted = true;
        }

        let result = await apiFunctions.getAllTag(limit, debouncedSearch, page, options);
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            setIsloading(false)
        } else {
            setAll(result.data.data);
            setUsersCount(result.data.total_count)
            setIsloading(false)
        }
    }

    useEffect(() => {
        getAll()
    }, [debouncedSearch, limit, page, statusFilter])

    const applyStatusChange = async () => {
        const { id, inactivate } = statusTarget;
        const result = inactivate
            ? await apiFunctions.removeTag(id)
            : await apiFunctions.updateTag(id, { isDeleted: false });

        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            setOpenDialogForStatus(false);
            getAll();
            toast.success(result.data.message || (inactivate ? "Tag inactivated successfully!" : "Tag activated successfully!"), {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.value === usersCount) {
            setSkip(0)
            setLimit(usersCount)
            setPage(1)
        } else {
            setLimit(e.target.value)
            setPage(1)
            setSkip(0)
        }
    };

    const skipPagination = (e, nextPage) => {
        setSkip((nextPage - 1) * limit)
        setPage(nextPage)
    }

  return (
    <>
    <div className='container'>
        {isLoading ? (
            <Loader />) : (
            <>
                <Toptag />
                <ToastContainer autoClose={1000} />
                <NavPaper>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div></div>
                        <Grid container spacing={4} direction="row" justifyContent="flex-end" alignItems="center">
                            <Grid item><div style={{ fontSize: "15px", fontWeight: "400", color: "grey" }}>Total Tags - {usersCount}</div></Grid>
                            <Grid item><div style={{ fontSize: "15px", fontWeight: "400", color: "grey" }}>Status - </div></Grid>
                            <Grid item>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 90 }}>
                                    <Select
                                        value={statusFilter}
                                        displayEmpty
                                        onChange={(e) => {
                                            setStatusFilter(e.target.value);
                                            setPage(1);
                                            setSkip(0);
                                        }}
                                    >
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="true">Active</MenuItem>
                                        <MenuItem value="false">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item><div style={{ fontSize: "15px", fontWeight: "400", color: "grey" }}>Row Per Page - </div></Grid>
                            <Grid item>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 50 }}>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard-label"
                                        value={limit}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="5">5</MenuItem>
                                        <MenuItem value="10">10</MenuItem>
                                        <MenuItem value="20">20</MenuItem>
                                        <MenuItem value="30">30</MenuItem>
                                        <MenuItem value={usersCount}>All</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <div className='searchBar'>
                                    <input type="text" placeholder='Search... ' onChange={searchHandle} id='searchtext' className='searchBarInput' />
                                    <Search className='searchIcon' />
                                </div>
                            </Grid>
                            <Grid item>
                                <button className='newBtn' onClick={handleCreateOpen}>Add Tag</button>
                            </Grid>
                        </Grid>

                    </div>
                </NavPaper>
                <BackPaper>
                {all.length === 0 ?
                            <Grid container spacing={2} style={{ marginTop: "30px" }} direction="column" justifyContent="space-evenly" alignItems="center">
                                <Grid item><img src="/images/nodata.jpg" alt="error-image" style={{ height: "150px", width: "200px" }} /></Grid>
                                <Grid item><div className="errorMessage">Tags not found!</div></Grid>
                            </Grid> :
                            <>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>S.No</TableCell>
                                            <TableCell>Title</TableCell>
                                            <TableCell>Created Since</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell align="center">Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {all.map((element, index) => {
                                            let date = new Date(element.createdAt);
                                            let monthsArray = ["Jan", "Feb", "March", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec",];
                                            let joinedSince = `${date.getDate()} ${monthsArray[date.getMonth()]} ${date.getFullYear()}`
                                            const isInactive = element.isDeleted === true;
                                            return (
                                                <TableRow key={element._id || index + 1}>
                                                    <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                                                    <TableCell>{element.title}</TableCell>
                                                    <TableCell>{joinedSince}</TableCell>
                                                    <TableCell>
                                                        {isInactive ? (
                                                            <Chip label="Inactive" className="statusChipBlock" />
                                                        ) : (
                                                            <Chip label="Active" className="statusChipActive" />
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center">
                                                            <Grid item>
                                                                <Tooltip title="Edit tag">
                                                                    <Edit className="visibilityIc" onClick={() => handleEditOpen(element)} />
                                                                </Tooltip>
                                                            </Grid>
                                                            <Grid item>
                                                                {isInactive ? (
                                                                    <Tooltip title="Activate tag">
                                                                        <RemoveCircleOutline
                                                                            className="blockIcon"
                                                                            style={{ color: "green" }}
                                                                            onClick={() => handleStatusOpen(element._id, false)}
                                                                        />
                                                                    </Tooltip>
                                                                ) : (
                                                                    <Tooltip title="Inactivate tag">
                                                                        <RemoveCircleOutline
                                                                            className="userListDelete"
                                                                            onClick={() => handleStatusOpen(element._id, true)}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </>
                        }


                    <Dialog open={openDialogForStatus} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            {statusTarget.inactivate
                                ? "Inactivate this tag? Existing events keep it; it will not appear for new add/edit."
                                : "Activate this tag? It will be available again for new events."}
                        </DialogTitle>
                        <DialogActions>
                            <Button onClick={handleStatusClose}>No</Button>
                            <Button onClick={applyStatusChange}>Yes</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={dialogOpen} aria-labelledby="responsive-dialog-title" >
                        <div className="popUpCreate">
                            <div style={{ display: 'flex', justifyContent: "flex-end", alignItems: 'center' }}>
                                <Cancel style={{ fontSize: "25px", color: "black", cursor: "pointer" }} onClick={handleDialogClose} />
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div className='popHeading'>{editId ? "Edit Tag" : "Create New Tag"}</div>
                            </div>
                            <div style={{ marginTop: "10px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "flex-start" }}>
                                    <div className="popText">Title</div>
                                    <input type="text" className="popInput" name="title" id="title" value={obj.title} onChange={addUserData} placeholder="Enter tag title" />
                                    {err && !obj.title ? <div className="errText">Title is required!</div> : null}
                                </div>
                            </div>

                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "15px", marginBottom: "15px" }}>
                                <div>
                                    <button className='popBtn' onClick={handleSubmit}>{editId ? "Update" : "Create"}</button>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: "center", alignItems: 'center', marginTop: "20px", marginBottom: "20px" }}>
                        <div>
                            <Pagination count={Math.max(1, Math.ceil(usersCount / limit) || 1)} page={page} variant="outlined" onChange={skipPagination} shape="rounded" />
                        </div>
                    </div>
                </BackPaper>

            </>
        )}
    </div>
</>
  )
}
